module.exports = __webpack_public_path__ + "static/media/ComplexTemplate.9ede15b3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/documents/ComplexTemplate.pdf
// module id = 3838
// module chunks = 0